import { render, staticRenderFns } from "./PublishApproval.vue?vue&type=template&id=3e62f9cf"
import script from "./PublishApproval.vue?vue&type=script&lang=js"
export * from "./PublishApproval.vue?vue&type=script&lang=js"
import style0 from "./PublishApproval.vue?vue&type=style&index=0&id=3e62f9cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports